const keyMirror = require("keymirror");

module.exports = keyMirror({
  USER_SET_LANG_WILL_SET: null,
  USER_SET_LANG_DID_SET: null,
});
